import { StyleSheet, View } from 'react-native';

import { Button, IconLocked, tokens } from '@fhs/ui';

type ReloadGiftCardButtonProps = {
  onPress: () => void;
};

export default function ReloadGiftCardButton({ onPress }: ReloadGiftCardButtonProps) {
  return (
    <View style={styles.buttonContainer}>
      <Button size="xl" onPress={onPress}>
        <Button.Icon size={20}>
          <IconLocked />
        </Button.Icon>
        <Button.Text>Reload Gift Card & Pay</Button.Text>
      </Button>
    </View>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    borderTopColor: tokens.colors.$black10,
    borderTopWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 'auto',
    padding: 16,
    width: '100%',
  },
});
